const paths = {
  admin: {
    MANAGE_USERS: "manage-users",
  },
  authenticated: {
    ADHOC_REPORT: "adhoc_report",
    USER_ACCOUNTS: "accounts",
    DASHBOARD: "dashboard",
    ACCOUNT: "account",
    REPORTS: "reports",
    PROJECTS: "projects",
    AUDIENCES: "audiences",
  },
  open: {
    FORGOT: "forgot-password-verification",
    UPDATE: "update-password",
    RESET: "reset-password",
    LOGIN: "login",
  },
};

export default paths;
